import {CarListDynamic} from "../src/offer/list/components/CarListDynamic";
import {prepareHydratedApp} from "./utils/prepare_hydrate_app";

const config = [{reactDynamic: "offer-list", view: <CarListDynamic />}];

(() => prepareHydratedApp(config))();
